import type { ObjectValues } from 'utils/types';

export const SavedSearchFrequency = {
	DAILY: 'day',
	HOURLY: 'hour',
	NONE: 'none',
} as const;
export type SavedSearchFrequency = ObjectValues<typeof SavedSearchFrequency>;
